import slice from './authentication.slice'

const { setIsStaffUser, setAuthInitialized } = slice.actions

export { setAuthInitialized, setIsStaffUser }
